<template>
  <div
    class="live-box-item"
    @click="goLive"
  >
    <div class="live-box-item-img">
      <img v-lazy="`${cover}?x-oss-process=image/resize,m_fill,w_334,h_204`" alt />
    </div>
    <div class="live-box-item-details">
      <span class="title">{{title}}</span>
      <div class="bottom">
        <span>{{students}}人学过</span>
        <span class="bottom-right">{{type}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0
    },
    cover: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    students: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: '在线直播'
    }
  },
  methods: {
    goLive () {
      this.$router.push(`/exerland/RefiningDetails/${this.id}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.live-box-item {
  display: inline-block;
  width: calc(50% - 7px);
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 14px;
  padding-bottom: 24px;
  position: relative;
  box-sizing: border-box;
  .live-box-item-img {
    box-sizing: border-box;
    width: 100%;
    height: calc(44.53vw * 204 / 334);
    background: rgba(245, 245, 245, 1);
    border-radius: 8px 8px 0 0;
    img {
      border-radius: 8px 8px 0 0;
      width: 100%;
    }
  }
  .live-box-item-details {
    padding: 7px 9px 5px 9px;
    .title {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      text-overflow: ellipsis;
    }
    .bottom {
      width: 100%;
      position: absolute;
      left: 9px;
      bottom: 5px;
      margin-top: 8px;
      font-size: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(136, 136, 136, 1);
      .bottom-right {
        position: absolute;
        bottom: 0;
        right: 18px;
      }
    }
  }
}
</style>
